const product = {
  information: "Information", // translated
  additionalInformation: "Informations Complémentaires", // translated
  contactUs: "Nous contacter", // translated
  contactUsText: "Vous souhaitez personnaliser votre visite ou vous avez d'autres questions ?", // translated
  dropUsAnEmail: "Envoyez-nous un e-mail", // translated
  viewLess: "Voir moins", // translated
  viewMore: "Voir plus", // translated
  less: "moins", // translated
  more: "Suite", // translated
  highlights: "Points forts", // translated
  inclusions: "Inclusions", // translated
  exclusions: "Exclusions", // translated
  pleaseWait: "S'il vous plaît, attendez...", // translated
  tourType: "Type de visite", // translated
  search: "Recherche", // translated
  available: "Disponible", // translated
  availableTours: "Circuits disponibles", // translated
  sortBy: "TRIER PAR", // translated
  priceLowToHigh: "Prix croissant", // translated
  priceHighToLow: "Prix : du plus élevé au plus bas", // translated
  mostPopular: "Le plus populaire", // translated
  roomOnly: "Chambre seulement", // translated
  bedAndBreakfast: "lit et petit-déjeuner", // translated
  halfBoard: "La moitié du tableau", // translated
  fullBoard: "Pension complète", // translated
  allInclusive: "Tout inclus", // translated
  viewDetails: "Voir les détails", // translated
  close: "proche", // translated
  at: "À", // translated
  person: "personne", // translated
  cancellationPolicy: "Politique d'annulation", // translated
  cancellationIs: "l'annulation est", // translated
  to: "pour", // translated
  bookingRemarks: "Remarques de réservation", // translated
  totalPrice: "Prix total", // translated
  back: "Arrière", // translated
  bookNow: "Reserve maintenant", // translated
  minutes: "Minutes", // translated
  visitDuration: "Durée de la visite", // translated
  itinerary: "Itinéraire", // translated
  airportToHotel: "De l'aéroport à l'hôtel", // translated
  hotelToAirport: "De l'hôtel à l'aéroport", // translated
  details: "des détails", // translated
  servicesDetails: "Détails des prestations", // translated
  services: "Prestations de service", // translated
  day: "Jour", // translated
  next: "Suivant", // translated
  nextStep: "L'étape suivante", // translated
  skip: "Sauter", // translated
  remarks: "Remarques", // translated
  optional: "optionnel", // translated
  guests: "Invités", // translated
  payment: "Paiement", // translated
  pickup: "Récupérer", // translated
  featuredPackage: "Forfait en vedette", // translated
  flights: "Vols", // translated
  accommodation: "Logement", // translated
  transfers: "Transferts", // translated
  tours: "Visites", // translated
  experiences: "Expériences", // translated
  featuredTour: "Visite en vedette", // translated
  From: "Depuis", // translated
  Accommodation: "Logement", // translated
  approxDuration: "Environ. durée", // translated
  travellerInformation: "Informations voyageurs", // translated
  bookingOverview: "Aperçu de la réservation", // translated
  checkout: "Vérifier", // translated
  paymentFailed: "Paiement échoué", // translated
  paymentSuccess: "Succès du paiement", // translated
  night: "Nuit", // translated
  viewEscapes: "Voir l'évasion", // translated
  escapeType: "Type d'échappement", // translated
  adultsOnly: "Seulment les adultes", // translated
  totalDuration: "Durée totale", // translated
  product: "Produit", // translated
  viewExperience: "Voir l'expérience", // translated
  childrenAreNotAllowedInThisTour: "Les enfants ne sont pas autorisés dans cette visite", // translated
  nights: "Nuits", // translated
  products: "Des produits", // translated
  departingAirport: "Aéroport de départ", // translated
  options: "Possibilités", // translated
};


export default product;
